import React, { Component } from "react";

import {
  Card,
  CardDeck,
  Col,
  Row,
  Container,
  Button,
  Jumbotron,
} from "react-bootstrap";
import { jumbotron_bg } from "../../images";
import history from "../../history";
import { Link } from "react-router-dom";
class SettingsDefault extends Component {
  state = {
    items: [
      {
        img: null,
        name: "Branch Categories",
        path: "/pawnshop-reports/branch-categories",
        summary: "Manages Branch Category Details",
      },
      {
        img: null,
        name: "Inventory Target",
        path: "/pawnshop-reports/target",
        summary: "Manages Overall, Cluster and Area Targets",
      },
    ],
  };
  render() {
    return (
      <Container className="mb-5" fluid>
        <Row>
          <Col>
            <Jumbotron
              className="text-light shadow"
              style={{
                backgroundImage: `url(${jumbotron_bg})`,
              }}
            >
              <h1>Settings</h1>
              <p>Please select the settings you want to manage</p>
            </Jumbotron>
          </Col>
        </Row>
        <Row>
          <Col>
            <CardDeck className="align-content-start justify-content-center">
              {this.state.items.map((item, key) => {
                return (
                  <Card key={key}
                    onClick={() => history.push(item.path)}
                    className="border-0 shadow custom_card"
                  >
                    <Card.Body>
                      <Card.Title>{item.name}</Card.Title>
                      <Card.Subtitle className="text-black-50">
                        {item.summary}
                      </Card.Subtitle>
                      <Link className="float-right mt-2" to={item.path}>
                        <Button variant="primary" size="md">
                          Manage
                        </Button>
                      </Link>
                    </Card.Body>
                  </Card>
                );
              })}
            </CardDeck>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SettingsDefault;
